import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Martina Sosa',
  age: 22,
  city: 'CABA',
  text: 'Estoy en 4to año y este pack me ordenó la cabeza como nada me había ordenado antes. Las tablas de dosis ya las tengo guardadas en el celular y son ORO en la rotación clínica.'
}, {
  name: 'Juan Cruz Méndez',
  age: 24,
  city: 'Mendoza',
  text: 'El capítulo de emergencias me salvó la guardia. Llegó un perro con golpe de calor y supe exactamente qué hacer. La tarjeta imprimible vale ella sola lo que pagué.'
}, {
  name: 'Sofía Aguirre',
  age: 21,
  city: 'Tucumán',
  text: 'Sentía que estudiaba un montón y no me quedaba nada. Con el planificador de 90 días empecé a retener de verdad. Aprobé patología en primera con 9.'
}, {
  name: 'Nicolás Vega',
  age: 26,
  city: 'Bahía Blanca',
  text: 'Soy recién recibido y este material me hubiera ahorrado AÑOS de inseguridad. Las plantillas clínicas las uso todos los días en mi primer trabajo. Recomendado al 100%.'
}, {
  name: 'Valentina Romero',
  age: 23,
  city: 'Neuquén',
  text: 'Me daba pánico la farmacología y los gatos. El bono del vademécum con las contraindicaciones señalizadas me cambió la forma de pensar cada caso. Vale cada peso.'
}];
export function Testimonials() {
  return <section className="w-full py-16 px-4 bg-white" data-id="element-213">
      <div className="max-w-5xl mx-auto" data-id="element-214">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center text-slate-900" data-id="element-215">
          Lo que dicen otros estudiantes argentinos
        </h2>
        <p className="text-center text-slate-600 mt-3 max-w-2xl mx-auto" data-id="element-216">
          Más de 1.200 estudiantes ya están estudiando con criterio gracias a
          Carrera Veterinaria 360.
        </p>

        <div className="grid md:grid-cols-2 gap-5 mt-10" data-id="element-217">
          {testimonials.map((t, i) => <div key={i} className="bg-green-50/40 border border-green-100 rounded-2xl p-5 shadow-sm hover:shadow-md transition" data-id="element-218">
              <div className="flex items-center gap-1 mb-2" data-id="element-219">
                {[1, 2, 3, 4, 5].map(s => <StarIcon key={s} className="w-4 h-4 text-yellow-500 fill-yellow-500" data-id="element-220" />)}
              </div>
              <p className="text-slate-700 leading-relaxed text-sm sm:text-base" data-id="element-221">
                "{t.text}"
              </p>
              <div className="mt-4 flex items-center gap-3" data-id="element-222">
                <div className="w-10 h-10 rounded-full bg-green-600 text-white font-bold flex items-center justify-center text-sm" data-id="element-223">
                  {t.name.split(' ').map(n => n[0]).join('').slice(0, 2)}
                </div>
                <div data-id="element-224">
                  <p className="font-bold text-slate-900 text-sm" data-id="element-225">
                    {t.name}, {t.age}
                  </p>
                  <p className="text-xs text-slate-500" data-id="element-226">
                    Estudiante de Veterinaria — {t.city}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}